<template>
  <div class="navbar">
    <hamburger
      :toggle-click="toggleSideBar"
      :is-active="sidebar.opened"
      class="hamburger-container"
    />
    <breadcrumb class="breadcrumb-container" />
    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <search class="right-menu-item" />
        <error-log class="errLog-container right-menu-item hover-effect" />
        <screenfull class="right-menu-item hover-effect" />
        <el-tooltip
          :content="$t('navbar.size')"
          effect="dark"
          placement="bottom"
        >
          <size-select class="right-menu-item hover-effect" />
        </el-tooltip>

        <lang-select class="right-menu-item hover-effect" />
        <el-tooltip
          :content="$t('navbar.theme')"
          effect="dark"
          placement="bottom"
        >
          <theme-picker class="right-menu-item hover-effect" />
        </el-tooltip>
        <span class="name">登陆用户：{{ name }}</span>
      </template>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
        :hide-on-click="false"
      >
        <div class="avatar-wrapper">
          <img
            :src="'https://portrait.gitee.com/uploads/avatars/user/583/1751938_Crazygoku_1578959167.png'"
            class="user-avatar"
          />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>
              {{ $t("navbar.dashboard") }}
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item v-permission="[-1]">
            <el-switch
              v-model="autoStatus.code_auto_review"
              inactive-text="开启激活码自动审核"
              @change="
                (key) =>
                  changeAutoStatusFun('code_auto_review', key ? '1' : '0')
              "
            >
            </el-switch>
          </el-dropdown-item>
          <el-dropdown-item v-permission="[-1]">
            <el-switch
              v-model="autoStatus.order_auto_review"
              inactive-text="开启订单自动审核"
              @change="
                (key) =>
                  changeAutoStatusFun('order_auto_review', key ? '1' : '0')
              "
            >
            </el-switch>
          </el-dropdown-item>
          <!-- <el-dropdown-item v-permission="[-1]">
            <el-switch
              v-model="autoStatus.message_auto_send"
              inactive-text="开启审核短信发送"
              @change="
                (key) =>
                  changeAutoStatusFun('message_auto_send', key ? '1' : '0')
              "
            >
            </el-switch>
          </el-dropdown-item>
          <el-dropdown-item v-permission="[-1]">
            <el-switch
              v-model="autoStatus.order_message_auto_send"
              inactive-text="开启订单短信发送"
              @change="
                (key) =>
                  changeAutoStatusFun(
                    'order_message_auto_send',
                    key ? '1' : '0'
                  )
              "
            >
            </el-switch>
          </el-dropdown-item> -->
          <el-dropdown-item v-permission="[-1]">
            <el-switch
              v-model="autoStatus.send_message_to_seller"
              inactive-text="开启发给销售"
              @change="
                (key) =>
                  changeSysConfigFun('send_message_to_seller', key ? '1' : '0')
              "
            >
            </el-switch>
          </el-dropdown-item>
          <el-dropdown-item v-permission="[-1]">
            <el-switch
              v-model="autoStatus.send_message_to_user"
              inactive-text="开启发给用户"
              @change="
                (key) =>
                  changeSysConfigFun('send_message_to_user', key ? '1' : '0')
              "
            >
            </el-switch> 
          </el-dropdown-item>
          <el-dropdown-item v-permission="[-1]">
            <formula-modal />
          </el-dropdown-item>
          <div v-if="roleStatus=='true'  ">
            <el-dropdown-item >
              <el-switch
                v-model="allList"
                inactive-text="查看全部列表"
                @change="(key) => changeCheckList(key)"
              >
              </el-switch>
            </el-dropdown-item>
          </div>
          <div else>
            <el-dropdown-item v-permission="[-1]">
              <el-switch
                v-model="allList"
                inactive-text="查看全部列表"
                @change="(key) => changeCheckList(key)"
              >
              </el-switch>
            </el-dropdown-item>
          </div>


          
    
          <el-dropdown-item divided>
            <span style="display: block" @click="logout">{{
              $t("navbar.logOut")
            }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import ErrorLog from "@/components/ErrorLog";
import Screenfull from "@/components/Screenfull";
import SizeSelect from "@/components/SizeSelect";
import LangSelect from "@/components/LangSelect";
import ThemePicker from "@/components/ThemePicker";
import Search from "@/components/HeaderSearch";
import FormulaModal from '@/views/components/formulaModal.vue';

import { checkPermi } from '@/utils/permission';


import {
  getAutoStatus,
  changeAutoStatus,
  getSysConfig,
  changeSysConfig,
} from "@/api/system";
export default {
  data() {
    return {
      autoStatus: {
        code_auto_review: false,
        order_auto_review: false,
        message_auto_send: false,
        order_message_auto_send: false,
        send_message_to_seller: false,
        send_message_to_user: false,
      },
    };
  },
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    LangSelect,
    ThemePicker,
    Search,
    FormulaModal
  },
  computed: {
    ...mapGetters(["sidebar", "name", "avatar", "device", "allList","roleStatus"]),
  },
  created() {
    console.log(this.roleStatus); 
   },
  mounted() {
    this.getAutoStatusFun("code_auto_review");
    this.getAutoStatusFun("order_auto_review");
    this.getAutoStatusFun("message_auto_send");
    this.getAutoStatusFun("order_message_auto_send");
    this.getSysConfigFun();
  },
  methods: {
    checkPermi,
    changeCheckList(key) {
      this.$store.dispatch("setAllList", key);
    },
    changeAutoStatusFun(type, key) {
      changeAutoStatus({ name: type, key }).then((res) => {
        const respones = res.data;
        if (respones.code == 200) {
          this.getAutoStatusFun(type);
          this.$message.success("修改成功");
        }
      });
    },
    changeSysConfigFun(type, key) {
      changeAutoStatus({ name: type, key }).then((res) => {
        const respones = res.data;
        if (respones.code == 200) {
          this.getSysConfigFun();
          this.$message.success("修改成功");
        }
      });
    },
    getAutoStatusFun(type) {
      getAutoStatus({ name: type }).then((res) => {
        const data = res.data.data;
        this.autoStatus[type] = data.key === "1";
      });
    },
    getSysConfigFun() {
      getSysConfig().then((res) => {
        const data = res.data.data;
        data.forEach((v) => {
          if (
            v.name === "send_message_to_user" ||
            v.name === "send_message_to_seller"
          ) {
            this.autoStatus[v.name] = v.key === "1";
          }
        });
        // this.autoStatus[type] = data.key === "1";
      });
    },
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // In order to re-instantiate the vue-router object to avoid bugs
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  .name {
    display: inline-block;
    height: 100%;
    font-size: 14px;
    color: #5f5b5b;
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
